import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ce97544"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "account" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("新建下属企业")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("锁定")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("解锁")
const _hoisted_7 = { class: "createOrUpdateMember" }
const _hoisted_8 = { class: "dialog-footer" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("取消")

import { defineComponent } from "vue";
import store from "@/store/index";
import { useStore } from "@/store/index";
import { ref, reactive } from "vue";
import tool from "@/utils/tool";
import router from "@/router/index";
import { ElButton, ElMessage, ElMessageBox } from "element-plus";
import type { ElForm, Action } from "element-plus";

    interface CompanyVo {
      id: string;
      code: string;
      name: string;
      shortName:string;
      type:string;
      contact:string;
      mobile:string;
      status: number;
    }

    type FormInstance = InstanceType<typeof ElForm>;
    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const ustore = useStore();
    const loading = ref(true)

    const createOrEditFormData: CompanyVo = {
      id: "",
      code: "",
      name: "",
      shortName:"",
      type:"",
      contact:"",
      mobile:"",
      status: 1
    };
    const bindData = reactive({
      subCompanyStatusOptions: [
        {
          value: "",
          label: "全部状态",
        },
        {
          value: "1",
          label: "正常",
        },
        {
          value: "2",
          label: "过期",
        },
        {
          value: "3",
          label: "锁定",
        },
      ],
      memberRoleList: [],
      pageParams: {
        curPage: 1,
        pageSize: 10,
        filtrate: {
          status: "",
          keyword: "",
        },
      },
      pageResult: {
        status: 2000,
        msg: "成功",
        result: [],
        totalCount: 0,
      },
      createOrEditFormData: createOrEditFormData,
      createOrEditFormTitle: "",
    });

    const handleSizeChangeEvent = (value: any) => {
      bindData.pageParams.pageSize = value;
      bindData.pageParams.curPage = 1;
      searchEvent();
    };

    const handleCurrentChangeEvent = (value: any) => {
      bindData.pageParams.curPage = value;
      searchEvent();
    };

    const searchEvent = () => {
      store
        .dispatch("subCompanyListModule/pageCompanyList", bindData.pageParams)
        .then(
          (data) => {
            //成功
            for (var index in data.result) {
              const obj = data.result[index];
              switch (obj.status) {
                case 1:
                  obj.statusName = "正常";
                  break;
                case 2:
                  obj.statusName = "过期";
                  break;
                case 3:
                  obj.statusName = "锁定";
                  break;
                default:
                  obj.statusName = "--";
                  break;
              }
            }
            bindData.pageResult = data;
            loading.value = false;
          },
          (error) => {
            console.log(error.msg);
          }
        );
    };

    searchEvent();

    //新增或更新
    const createOrEditDialogVisible = ref(false);


    const showCreateFormEvent = () => {
      createOrEditDialogVisible.value = true;
      bindData.createOrEditFormData = {
       id: "",
       code: "",
       name: "",
       shortName:"",
       type:"",
       contact:"",
       mobile:"",
       status: 1
      };
      bindData.createOrEditFormTitle = "新建下属企业";
    };

    const showUpdateFormEvent = (index: number, row: CompanyVo) => {
      createOrEditDialogVisible.value = true;
      bindData.createOrEditFormData.id = row.id;
      bindData.createOrEditFormData.name = row.name;
      bindData.createOrEditFormData.shortName = row.shortName;
      bindData.createOrEditFormData.type = row.type;
      bindData.createOrEditFormData.contact = row.contact;
      bindData.createOrEditFormData.mobile = row.mobile;
      console.log(bindData.createOrEditFormData);
      bindData.createOrEditFormTitle = "修改下属企业";
    };


    const updateCompanyStatusEvent = (index: number, row: CompanyVo) => {
      var msg = "您确定要锁定吗？";
      var status = 3;
      if(row.status == 3){
         msg = "您确定要解锁吗？";
         status = 1;
      }
      ElMessageBox.confirm(`${msg} ${row.name} [${row.code}] 吗?`)
        .then(() => {
          const params = {
            id: row.id,
            status:status
          };
          store.dispatch("subCompanyListModule/updateCompanyStatus", params).then(
            (data) => {
              //成功
              if(status == 3){
                 ElMessage.success("锁定成功.");
              } else {
                 ElMessage.success("解锁成功.");
              } 
              searchEvent();
            },
            (error) => {
              ElMessageBox.alert(error.msg, "系统消息", {
                confirmButtonText: "关闭",
                callback: (action: Action) => {},
              });
            }
          );
        })
        .catch(() => {
          // catch error
        });
    };

    const subCompanyFormRef = ref<FormInstance>();

    const validateCode = (rule: any, value: any, callback: any) => {
      if (value === "") {
        callback(new Error("请输入账号"));
      } else {
        callback();
      }
    };

    const validateName = (rule: any, value: any, callback: any) => {
      if (value === "") {
        callback(new Error("请输入名称"));
      } else {
        callback();
      }
    };

    const validateShortName = (rule: any, value: any, callback: any) => {
      if (value === "") {
        callback(new Error("请输入简称"));
      } else {
        callback();
      }
    };

    const memberRules = reactive({
      code: [{ required: true, validator: validateCode, trigger: "blur" }],
      name: [{ required: true, validator: validateName, trigger: "blur" }],
      shortName: [{ required: true, validator: validateShortName, trigger: "blur" }],
    });

    const submitMemberForm = (formEl: FormInstance | undefined) => {
      if (!formEl) return;
      formEl.validate((valid) => {
        if (valid) {
          store
            .dispatch(
              "subCompanyListModule/saveSubCompany",
              bindData.createOrEditFormData
            )
            .then(
              (data) => {
                //成功
                createOrEditDialogVisible.value = false;
                if (
                  data.result &&
                  data.result.password &&
                  data.result.password.length > 0
                ) {
                  ElMessageBox.alert(
                    `保存成功. 账号：${data.result.code}  初始密码: ${data.result.initialPassword}`,
                    "系统消息",
                    {
                      confirmButtonText: "关闭",
                      callback: (action: Action) => {},
                    }
                  );
                } else {
                  ElMessage.success("保存成功");
                }

                searchEvent();
              },
              (error) => {
                ElMessageBox.alert(error.msg, "系统消息", {
                  confirmButtonText: "关闭",
                  callback: (action: Action) => {},
                });
              }
            );
        } else {
          console.log("error submit!");
          return false;
        }
      });
    };


return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, { class: "account-search" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, { class: "account-search-lt" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(bindData).pageParams.filtrate.status,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(bindData).pageParams.filtrate.status) = $event)),
                  placeholder: "全部状态",
                  size: "large",
                  onChange: searchEvent
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).subCompanyStatusOptions, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { class: "account-search-lt-text" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  placeholder: "清输入名称、简称、编码搜索",
                  style: {"width":"233px"},
                  size: "large",
                  onKeyup: _withKeys(searchEvent, ["enter"]),
                  modelValue: _unref(bindData).pageParams.filtrate.keyword,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(bindData).pageParams.filtrate.keyword) = $event)),
                  modelModifiers: { trim: true }
                }, null, 8, ["onKeyup", "modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { class: "account-search-lt-btn" }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElButton), {
                  type: "primary",
                  size: "large",
                  onClick: searchEvent
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(ElButton), {
          class: "account-search-rt",
          type: "primary",
          size: "large",
          onClick: showCreateFormEvent
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: _unref(bindData).pageResult.result,
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "名称",
          width: "130"
        }),
        _createVNode(_component_el_table_column, {
          prop: "shortName",
          label: "简称",
          width: "130"
        }),
        _createVNode(_component_el_table_column, {
          prop: "code",
          label: "编码",
          width: "130"
        }),
        _createVNode(_component_el_table_column, {
          prop: "typeDesc",
          label: "会员类型",
          width: "130"
        }),
        _createVNode(_component_el_table_column, {
          prop: "contact",
          label: "联系人",
          width: "130"
        }),
        _createVNode(_component_el_table_column, {
          prop: "mobile",
          label: "手机号",
          width: "130"
        }),
        _createVNode(_component_el_table_column, {
          prop: "statusName",
          label: "状态",
          width: "130"
        }),
        _createVNode(_component_el_table_column, {
          fixed: "right",
          label: "操作",
          width: "200"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_unref(ElButton), {
              type: "text",
              size: "small",
              onClick: ($event: any) => (showUpdateFormEvent(scope.$index, scope.row))
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 2
            }, 1032, ["onClick"]),
            (scope.row.status == 1)
              ? (_openBlock(), _createBlock(_unref(ElButton), {
                  key: 0,
                  type: "text",
                  size: "small",
                  onClick: ($event: any) => (updateCompanyStatusEvent(scope.$index, scope.row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            (scope.row.status == 3)
              ? (_openBlock(), _createBlock(_unref(ElButton), {
                  key: 1,
                  type: "text",
                  size: "small",
                  onClick: ($event: any) => (updateCompanyStatusEvent(scope.$index, scope.row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, loading.value]
    ]),
    _createVNode(_component_el_container, { class: "account-page_toolbar" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_pagination, {
          currentPage: _unref(bindData).pageParams.curPage,
          "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((_unref(bindData).pageParams.curPage) = $event)),
          "page-size": _unref(bindData).pageParams.pageSize,
          "onUpdate:page-size": _cache[3] || (_cache[3] = ($event: any) => ((_unref(bindData).pageParams.pageSize) = $event)),
          "page-sizes": [10, 20, 50, 100],
          layout: "total, sizes, prev, pager, next, jumper",
          total: _unref(bindData).pageResult.totalCount,
          "onUpdate:total": _cache[4] || (_cache[4] = ($event: any) => ((_unref(bindData).pageResult.totalCount) = $event)),
          onSizeChange: handleSizeChangeEvent,
          onCurrentChange: handleCurrentChangeEvent
        }, null, 8, ["currentPage", "page-size", "total"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: createOrEditDialogVisible.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((createOrEditDialogVisible).value = $event)),
      title: _unref(bindData).createOrEditFormTitle,
      "onUpdate:title": _cache[12] || (_cache[12] = ($event: any) => ((_unref(bindData).createOrEditFormTitle) = $event)),
      width: "40%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_8, [
          _createVNode(_unref(ElButton), {
            type: "primary",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (submitMemberForm(subCompanyFormRef.value)))
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }),
          _createVNode(_unref(ElButton), {
            onClick: _cache[10] || (_cache[10] = ($event: any) => (createOrEditDialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_el_form, {
            ref_key: "subCompanyFormRef",
            ref: subCompanyFormRef,
            model: _unref(bindData).createOrEditFormData,
            "status-icon": "",
            rules: _unref(memberRules),
            "label-width": "120px",
            class: "subCompanyForm"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "名称",
                prop: "name"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(bindData).createOrEditFormData.name,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(bindData).createOrEditFormData.name) = $event)),
                    type: "text",
                    autocomplete: "off"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "简称",
                prop: "shortName"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(bindData).createOrEditFormData.shortName,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(bindData).createOrEditFormData.shortName) = $event)),
                    type: "text",
                    autocomplete: "off"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "联系人",
                prop: "contact"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(bindData).createOrEditFormData.contact,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(bindData).createOrEditFormData.contact) = $event)),
                    type: "text",
                    autocomplete: "off"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "手机号",
                prop: "mobile"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(bindData).createOrEditFormData.mobile,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(bindData).createOrEditFormData.mobile) = $event)),
                    type: "text",
                    autocomplete: "off"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})